import { render } from "./airtel.vue?vue&type=template&id=3f5f4675&scoped=true"
import script from "./airtel.vue?vue&type=script&lang=js"
export * from "./airtel.vue?vue&type=script&lang=js"

import "./airtel.vue?vue&type=style&index=0&id=3f5f4675&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5f4675"]])

export default __exports__